// Mobile Menu - Drawer & Accordion Behavior

document.addEventListener('DOMContentLoaded', () => {
  const $mobileMenu = document.querySelector('.js-mobile-menu__drawer');
  const $backdrop = document.querySelector('.js-mobile-menu-backdrop');
  const $openButton = document.querySelector('.js-menu-toggle');

  // Open menu
  document.addEventListener('nova:mobile-menu:open', () => {
    // Recalculate header offset before opening menu
    window.dispatchEvent(new Event('resize'));

    $mobileMenu.classList.add('is-open');
    $backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  });

  // Close menu
  document.addEventListener('nova:mobile-menu:close', () => {
    $mobileMenu.classList.remove('is-open');
    $backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';

    // Return focus to open button
    if ($openButton) $openButton.focus();
  });

  // Close when clicking backdrop
  $backdrop.addEventListener('click', () => {
    const header = document.querySelector('#shopify-section-header');
    if (header) {
      header.classList.remove('menu-open');
    }

    document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'));
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && $mobileMenu.classList.contains('is-open')) {
      const header = document.querySelector('#shopify-section-header');
      if (header) {
        header.classList.remove('menu-open');
      }
      document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'));
    }
  });

  // Accordion behavior for submenus
  document.querySelectorAll('.accordion-submenu-header').forEach((button) => {
    button.addEventListener('click', () => {
      const accordionContent = button
        .closest('.accordion-item')
        .querySelector('.accordion-content');
      const isExpanded = button.classList.contains('active');

      button.classList.toggle('active');
      button.setAttribute('aria-expanded', !isExpanded);

      if (button.classList.contains('active')) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
      } else {
        accordionContent.style.maxHeight = 0;
      }
    });
  });
});
